import axios from "lib/axios";

export const updateInvoiceApi = async (data, id) => {
  return await axios.patch(`/resident_payments/invoices/${id}`, data);
};

